import { useTranslation } from 'react-i18next';

export const noDataDocViewer = () => {
  const { t } = useTranslation();
  return <span> { t( 'common:unable_to_load_file' ) } </span>;
};